export default __webpack_public_path__ + "static/eco-alliance-support-b817d664a0d7bdb2e8eec650b5ec785d.svg";